import React from "react";
import { compose } from "redux";
import { Typography, withStyles } from "@material-ui/core";
import { NavLink } from "react-router-dom";

const ViewTab = ({ classes, to, children, activeClassName, isActive }) => {
  return (
    <NavLink
      exact
      replace
      to={to}
      isActive={isActive}
      className={classes.viewTab}
      activeClassName={activeClassName}
    >
      <Typography className={classes.navLinkText} variant="body2">
        {children}
      </Typography>
    </NavLink>
  );
};

const styles = theme => ({
  viewTab: {
    padding: `${theme.spacing(1.75)}px ${theme.spacing(5)}px`,
    color: theme.palette.getContrastText(theme.altus.background.header),
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
    "&:hover $navLinkText": {
      textDecoration: "underline",
    },
  },
  navLinkText: {
    fontWeight: 500,
  },
});

export default compose(withStyles(styles))(ViewTab);
